import styled from 'styled-components'


export const FooterWrapper = styled.div`
width: 100vw;
height: 40px;
// background-color: brown;
display: flex;
justify-content: center;
align-items: center;
`;
export const Copy = styled.div`
font-family: Poppins;
font-size: 14px;
font-weight: 300;
color: #000000;
`;